import React, { useState } from "react";
import "./accordion.css";
import { useDispatch, useSelector } from "react-redux";
import { updateDesignParameter } from "../../../../Features/designParameter";
import { addNode, nearToLine, removeNode } from "./accordionFunction";

export default function Lines({ points, index }) {
  const [tooltip, setTooltip] = useState();
  const dispatch = useDispatch();
  const roofInfo = useSelector((state) => state.roof);
  const gridInfo = useSelector((state) => state.grid);
  const quantityInfo = useSelector((state) => state.quantity);
  const designParameter = useSelector((state) => state.designParameter);

  const roofPolygons = roofInfo?.value?.polygonCoordinates || [];
  const abstacles = roofInfo?.value?.abstacles || [];
  let updatePoints =
    roofPolygons.length > 0 && index <= roofPolygons.length - 1
      ? roofPolygons[index].updatedPoints
      : points;

  const polygonIndex = index;

  return updatePoints.map((item, i) => (
    <div
      className="ac-lines"
      key={i}
      onClick={() => dispatch(updateDesignParameter({ lineNo: i }))}
    >
      <div className="ac-title">
        <img src="../images/icons/lineIcon.svg" alt="roofIcon" className="lineIcon"></img>
        <span style={{ color: designParameter.lineNo === i ? "green" : "" }}>
          Line {i + 1}
        </span>
      </div>
      <div className="ac-action">
        <div
          className="actionBtn"
          onClick={() =>
            addNode({
              i,
              dispatch,
              quantityInfo,
              polygonIndex,
              roofPolygons,
              updatePoints,
            })
          }
        >
          {tooltip === `add${i}` && (
            <h4 className="warning">
              <div className="sideArrow"></div>
              Add Node
            </h4>
          )}
          <i
            className="bi bi-circle-fill"
            onMouseEnter={() => setTooltip(`add${i}`)}
            onMouseLeave={() => setTooltip()}
          ></i>
        </div>
        <div
          className="actionBtn"
          onClick={() =>
            nearToLine({
              i,
              updatePoints,
              quantityInfo,
              designParameter,
              gridInfo,
              roofInfo,
              dispatch,
              abstacles,
            })
          }
        >
          {tooltip === `wallAlign${i}` && (
            <h4 className="warning">
              <div className="sideArrow"></div>
              Near-to-Wall
            </h4>
          )}

          <img
            src="../images/icons/wallIcon.svg"
            alt="wallIcon"
            onMouseEnter={() => setTooltip(`wallAlign${i}`)}
            onMouseLeave={() => setTooltip()}
          ></img>
        </div>
        <div
          className="actionBtn"
          onClick={() =>
            removeNode({
              i,
              dispatch,
              updatePoints,
              roofPolygons,
              polygonIndex,
            })
          }
        >
          {tooltip === `delete${i}` && (
            <h4 className="warning">
              <div className="sideArrow"></div>
              Delete Line
            </h4>
          )}
          <i
            className="bi bi-trash-fill trashIcon"
            onMouseEnter={() => setTooltip(`delete${i}`)}
            onMouseLeave={() => setTooltip()}
          ></i>
        </div>
      </div>
    </div>
  ));
}
